import type { TelefoneBloqueado } from "../../../services/telefonesBloqueados"

export enum TelefoneBloqueadosActionsTypes {
    CARREGAR = "CARREGAR",
}

export type TelefoneBloqueadosActions = {
    type: TelefoneBloqueadosActionsTypes.CARREGAR
    payload: TelefoneBloqueado[]
}
